import * as React from "react";
import type { SVGProps } from "react";
const SvgAnrokIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={265.55}
    height={262.64}
    viewBox="0 0 265.55 242.64"
    {...props}
  >
    <path
      d="m161.42.05 104.13 179.3-32.93 59-65.3.51-44.7-75.01c7.88 28.95-6.83 61.06-34.34 73.16-48.47 21.32-98.79-21.24-86.37-72.38 11.23-46.22 69.25-61.82 103.7-29.79L63.12 61.76l-.09-2.92L93.78 0z"
      style={{
        fill: "#1f1f1f",
      }}
    />
  </svg>
);
export default SvgAnrokIcon;
